import { Box, Select, MenuItem } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVirtualBatteryTypes } from "@/actions/bateriaVirtual";
import { IBateriaVirtual, IVirtualBatteryTypes } from './types/bateriaVirtual';
import { RootState } from "@/store";

export interface IVirtualBatteryDiscountSelectProps {
  bateriaVirtual: IBateriaVirtual,
  handleBatteryModeChange: (value: string, bateria_id: number) => void
}

const VirtualBatteryDiscountSelect = ({
  bateriaVirtual,
  handleBatteryModeChange
}: IVirtualBatteryDiscountSelectProps) => {

  const dispatch = useDispatch();
  const theme = useTheme();
  const virtualBatteryTypes = useSelector((state: RootState) => state.bateriaVirtual.virtualBatteryTypes) as IVirtualBatteryTypes;

  useEffect(() => {
    if(!!virtualBatteryTypes){
      dispatch(fetchVirtualBatteryTypes());
    }
  }, []);

  return (
    <Box>
      <Select
        sx={{ 
          [theme.breakpoints.down("md")]: {
            width: '74vw'
          }
        }}
        value={bateriaVirtual.gestio_descomptes}
        onChange={(event) => {
          handleBatteryModeChange(event.target.value, bateriaVirtual.bateria.id);
        }}
      >
        {virtualBatteryTypes?.types?.map((p) => {
            return <MenuItem key={p.name} value={p.name}>{p.description}</MenuItem>
          })
        }
      </Select>
    </Box>
  );
};

export default VirtualBatteryDiscountSelect;
